import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";

import type { IOrderingResponse } from "../types";

import type { IPathBaseParam } from "./path";

const getApi = createGetApi<
  IApiResponse<IOrderingResponse>,
  IPathBaseParam,
  undefined
>("orderings.store");

export const store = {
  ...getApi,
};
